import axios from "../axios/axios";
import { AppBrand } from "../types/appBrand";

export const fetchAppBrands = async (): Promise<AppBrand[]> => {
  try {
    const response = await axios.get("/app_brand/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching App Brands:", error);
    throw new Error("Failed to fetch App Brands");
  }
};
